<div class="thumb-container" *ngIf="isAboutIoAvailable">
  <div class="img-container">
    <img [src]="learnImage" alt="">
  </div>
  <div class="thumb-title">
    <p class="nomargin">{{'Learn About' | translate }}</p>
    <p class="nomargin">{{'Immunotherapy' | translate }}</p>
  </div>
</div>
